/**
 * The two ways to get Teamy running on your own machine, as the public pages
 * show them: the self-host install command, and the Teamy Studio downloads.
 * One place, so the hero, the self-hosted section and the download page never
 * show different commands or files.
 */

export const SELFHOST_INSTALL_COMMAND = 'curl -fsSL https://dl.zibby.app/selfhosted/latest/install.sh | bash';

export const STUDIO_DOWNLOAD_BASE_URL = 'https://dl.zibby.app';

// The files the release script writes under download/latest/ (the download
// page swaps in the manifest's versioned file once it has loaded). Named after
// the app (selfhosted desktop/product.json productName). Releases from Teamy
// Studio on also keep writing the former "Zibby Studio-…" names, so links to
// those that are already out there keep getting the newest build.
// Still the former name: "Teamy Studio-…" files exist only once the first
// Teamy Studio release is out, and every release keeps writing the old names
// too. Switch to 'Teamy%20Studio' after that release.
const STUDIO_FILE_PREFIX = 'Zibby%20Studio';
export const STUDIO_LATEST_DOWNLOADS = {
  macArm:   `${STUDIO_DOWNLOAD_BASE_URL}/download/latest/${STUDIO_FILE_PREFIX}-mac-arm64.dmg`,
  macIntel: `${STUDIO_DOWNLOAD_BASE_URL}/download/latest/${STUDIO_FILE_PREFIX}-mac-x64.dmg`,
  winX64:   `${STUDIO_DOWNLOAD_BASE_URL}/download/latest/${STUDIO_FILE_PREFIX}-win-x64.exe`,
  winArm:   `${STUDIO_DOWNLOAD_BASE_URL}/download/latest/${STUDIO_FILE_PREFIX}-win-arm64.exe`,
};

/** The files the hero links: the fixed "latest" Apple Silicon dmg and the x64 Windows installer. */
export const STUDIO_HERO_DOWNLOADS = { mac: STUDIO_LATEST_DOWNLOADS.macArm, windows: STUDIO_LATEST_DOWNLOADS.winX64 };
